// Human-readable mapping for the engine's `rationale` codes emitted by
// `buildRationale` in `backend/.../phase4-rank-and-persist.ts`. Keep this
// map in sync when codes are added or renamed on the backend.

const HUMAN_RATIONALES: Record<string, string> = {
  transfer_surplus_found: 'Transfer from a warehouse with surplus',
  vendor_ship_to_ineligible_pivot_upstream:
    "Vendor won't ship here — pivot through hub",
  below_mov: 'Below vendor minimum order',
  no_surplus_buy: 'No transfer surplus — buy from vendor',
  in_stock_cut: 'Cut from a local unit already on hand',
  in_stock_whole: 'Ship a local unit already on hand',
  lot_level_deficit: 'Sized lots cannot cover this line within the join limit',
};

export function humanizeRationale(code: string | null | undefined): string {
  if (!code) return '—';
  return HUMAN_RATIONALES[code] ?? code.replace(/_/g, ' ');
}

export function rationaleRawForTooltip(
  code: string | null | undefined,
): string {
  return code ?? '';
}
